<template>
	<div id="add-choice" class="poll-add-choice">
		<div v-on:click="toggleAddChoiceDisp()" v-show="addChoiceDisp">
			<div class="addchoice dash-border-color-skin">
				<div class="dash-color-skin text-add-choice"> {{ labels[nowLang].pollAddChoice }}</div>
			</div>
		</div>
		<div v-show="!addChoiceDisp">
			<div class="dash-bg-color-skin-light-30 box-add-choice-fn">
				<template v-if="!hasImage">
					<input name="addText"
                 v-validate="'required'"
                 class="form-control dash-border-color-skin"
                 placeholder="Choice Detail"
                 autocomplete="off"
                 spellcheck="false"
                 autocorrect="off"
                 tabindex="1"
                 v-model="addText"
                 v-on:keyup.enter="addChoice()"
                 :class="{ 'input-error' : errors.has('addText') }">
					<div v-show="errors.has('addText')" class="text-error">{{ errors.first('addText') }}</div>
				</template>
				<template v-else>
					<div class="clearfix choice">
            <div v-if="activeDropzone" class="btn-add-pic">
              <hrms-dropzone  v-model="namImage"
                              :flgRename="false"
                              :othPath="filePath.save"
                              :acceptedFileTypes="'image/*'"
                              ref="hrmsDropzone" />
            </div>
              <!-- <img v-show="namImage" class="circle-dropzone" :src="fullPathImage">
  		        <i v-show="!namImage" class="fa fa-plus-circle"></i> -->
						<div class="setup-margin-input">
  						<input type="text"
                     name="addText"
                     v-validate="'required'"
                     class="dash-border-color-skin input-poll-choice"
                     :placeholder="labels[nowLang].choicePlaceHolder"
                     v-model="addText"
                     v-on:keyup.enter="addChoice()"
                     :class="{ 'input-error' : errors.has('addText') }">
  						<div v-show="errors.has('addText')" class="text-error">{{ errors.first('addText') }}</div>
						</div>
					</div>
				</template>
				<div class="row">
					<div class="col-xs-4 btn-add-choice1 dash-bg-color-skin-dark-20" v-on:click="addChoice()">{{ labels[nowLang].confirm }}</div>
					<div class="col-xs-4 btn-add-choice2 dash-bg-color-skin-dark-20" v-on:click="cancelChoice()">{{ labels[nowLang].cancel }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'add-choice',
  data () {
    return {
      addText: '',
      addChoiceDisp: this.collapsed,
      labels: {
        en: {
          pollAddChoice: '+ Add more choice',
          choicePlaceHolder: 'Input choice',
          confirm: 'Confirm',
          cancel: 'Cancel'
        },
        th: {
          pollAddChoice: '+ เพิ่มตัวเลือก',
          choicePlaceHolder: 'กรอกตัวเลือก',
          confirm: 'ยืนยัน',
          cancel: 'ยกเลิก'
        }
      },
      namImage: '',
      fullPathImage: '',
      activeDropzone: false
    }
  },
  watch: {
    'namImage' () {
      this.fullPathImage = this.namImage ? this.filePath.load + this.namImage : 'static/images/employee/no_image.png'
    }
  },
  props: [ 'collapsed', 'poll', 'hasImage', 'nowLang', 'postChoice', 'filePath' ],
  methods: {
    addChoice () {
      let _this = this
      this.$validator.validateAll().then(result => {
        swal({
          title: constLabels('confirmTitle'),
          text: constLabels('msgConfirmSave'),
          html: true,
          showCancelButton: true,
          closeOnConfirm: false,
          confirmButtonText: constLabels('ok'),
          cancelButtonText: constLabels('cancel')
        },
        function (isConfirm) {
          if (isConfirm) {
            if (result) {
              let choiceParams = {
                codpoll: _this.poll.codpoll,
                numseq: 0,
                image: (_this.hasImage) ? _this.namImage : '',
                text: _this.addText,
                number: 0,
                selected: 'N'
              }
              let sendParams = {
                p_codpoll: _this.poll.codpoll,
                p_descchoice: _this.addText,
                p_flgusradd: 'Y',
                p_imagename: _this.namImage
              }
              _this.postChoice({ sendParams: sendParams, choiceParams: choiceParams })
              _this.toggleAddChoiceDisp()
            }
          }
        })
      })
    },
    cancelChoice () {
      this.toggleAddChoiceDisp()
    },
    toggleAddChoiceDisp () {
      this.addChoiceDisp = !this.addChoiceDisp
      this.addText = ''
      if (this.hasImage) {
        this.activeDropzone = true
        this.namImage = ''
        if (this.activeDropzone) {
          this.$nextTick(() => {
            this.$refs.hrmsDropzone.clearDropzone()
          })
        }
      }
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  }
}
</script>

<style lang="scss">
  .circle-dropzone {
    height: 70px;
    width: 70px;
    border-radius: 50%;
  }

  .poll-add-choice {
    .vue-dropzone {
      &.dropzone {
        min-height: 0;
        padding: 0;
        width: 70px;
        height: 70px;
        border-radius: 100%;
        border: none;
        &.dz-clickable {
          &:before {
            content: "\f067";
            font-family: FontAwesome;
            font-size: 51px;
            margin-left: 16px;
            color: #e5a8c0;
            @media (max-width: 768px) {
              color: #b2b2b2;
            }
          }
          .dz-default.dz-message {
            display: none;
          }
          .dz-preview {
            background: none;
            margin: 0;
            min-height: 0;
            &:hover {
              .dz-remove {
                top: -35px;
                margin-left: 0;
                bottom: 0;
                border: none;
              }
            }
            .dz-image {
              width: 70px !important;
              height: 70px !important;
              border-radius: 100%;
              margin: -72px 0;
              img {
                width: 100%;
              }
            }
            .dz-details {
              top: -72px;
              padding: 3px;
              font-size: 10px;
              text-align: center;
              border-radius: 100%;
              .dz-size {
                margin-bottom: 0;
                font-size: 10px;
              }
            }
            .dz-progress {
              top: -30px;
              width: 90%;
              margin-left: -32px;
              height: 6px;
            }
            .dz-error-message {
              top: 0;
              left: -10px;
              &:after {
                left: 39px;
              }
            }
            .dz-success-mark {
              top: -40px !important;
              left: 40%;
              i {
                font-size: 16px !important;
              }
            }
            .dz-error-mark {
              top: -40px !important;
              left: 40%;
              i {
                font-size: 16px !important;
              }
            }
            .dz-remove {

            }
          }
        }
      }
    }
    .text-remark._text-blue {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// addChoice.vue?53cfa97a